
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PathwayBadges',
  props: {
    pathway: {
      type: Object,
      required: true,
    },
    extraClasses: {
      type: String,
      required: false,
      default: ''
    }
  }
});
